var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.getters.hasAnyRole(['SystemAdmin']))?_c('v-btn',{attrs:{"tile":"","outlined":"","text":"","small":""},on:{"click":_vm.navigateToExport}},[_c('v-icon',{attrs:{"small":""}},[_vm._v(" mdi-download ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }